<template>
  <div>
    <div v-if="order">
      <order-header></order-header>
    </div>
    <div class="row ibox-content">
      <site-list></site-list>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import SiteList from './Order/SiteList'
import OrderHeader from './Order/Header'
import { ORDER_SET } from '../../../store/mutation-types'

export default {
  data () {
    return {
    }
  },
  components: {
    siteList: SiteList,
    orderHeader: OrderHeader
  },
  mounted () {
    if (!this.filters.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.getOrder()
  },
  computed: {
    ...mapGetters({
      filters: 'getFilters',
      user: 'getUser',
      order: 'getOrder'
    })
  },
  methods: {
    getOrder () {
      axios.get('/pbn/order/' + this.$route.params.orderId)
        .then(r => {
          this.$store.commit(ORDER_SET, r.data)
          document.title = this.order.name + ' :: Orders :: PBN360 by Aphex Media'
        })
        .catch(e => {
          this.$toastr.error(e, 'Bad Luck Genghis')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Order.vue